import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DContextoMuisca, DError, DRespuestaSimple } from '@dian/core';
import { GeneralService } from '../../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DDocumento, DExtemporaneo, DInfoResumenFormulario, DVersionRutaFormato } from '@dian/api-formulario';
import { MatDialog } from '@angular/material';
import { ModoDiligenciemientoComponent } from '../shared/modals/modo-diligenciemiento/modo-diligenciemiento.component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DRenta210IngresoServicios } from '@dian-api/renta210-ingreso';
import { Buffer } from 'buffer';
import { ModalService, ModalType } from '../../modal/services/modal.service';
import { DFirmaComponente } from '@dian-cmp/firma';
import { Formulario210Servicio } from '../../services/formulario.servicio';
import { DItemExtemporaneidad, DMensajes, DOperacionesGeneralesIngresoServicio, DOperacionesMatematicasServicio, DTipoOperacionAritmetica, DTipoTransformacionModelo, DUtilidadesFormularioServicio } from '@dian-cmp/formulario';
import { SessionStorageService } from 'ngx-webstorage';
import { DRenta210v17Servicios } from '@dian-api/renta210v17';
import { DFormularioConfiguracion } from '../../configuracion/dformulario-configuracion';
import { DLiquidacionReciboExterior } from '@dian-api/recibo-pago490-exterior';
import { DReciboPagoExteriorDialogoServicio } from '@dian-cmp/recibo-pago490-exterior';
import { DConceptoLiquidacionRecibo, DLiquidacionRecibo, DRtaLiquidacionReciboPago } from '@dian-api/recibo-pago490';
import { DEnvioDataServicio } from '@dian-cmp/recibo-pago';
import { DRenta210v18Servicios } from '@dian-api/renta210v18';

@Component({
  selector: 'app-sugerida',
  templateUrl: './sugerida.component.html',
  styleUrls: ['./sugerida.component.css']
})
export class SugeridaComponent implements OnInit, AfterViewInit {

  datosUsuario: DContextoMuisca;
  versionesRuta: DVersionRutaFormato[];
  anioSugerida: number = 2023;
  sugerida: any;
  blob : Blob;
  botonFirmarYPagar = 'Firmar';
  datosFirmaContribuyente : any;
  nit : string;
  protected extemporaneidad: DExtemporaneo;
  configuracionFormulario : DFormularioConfiguracion = new DFormularioConfiguracion();
  step = 1;
  tabs: any = {
    generarRecibo: {value: true, title: 'Generar Recibo'},
    previsualizar: {value: false, title: 'Previsualizar'},
    datosPago: {value: false, title: 'Datos de pago'},
  }
  currentTab = this.tabs.generarRecibo;
  datosContexto = new DContextoMuisca();
  liquidacionSugerida: DLiquidacionRecibo;
  formulario490 = new DRtaLiquidacionReciboPago;
  tienePago = false;
  public aporteVoluntario:number;
  private operacionesGenerales: DOperacionesGeneralesIngresoServicio;

  constructor(private generalService: GeneralService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private dNotificacionServicio: DNotificacionServicio,
    private dServicioRESTAPI: DRenta210IngresoServicios,
    private dSerivicoFormulario210: Formulario210Servicio,
    private modalService: ModalService,
    private dServicio210_v18RESTAPI: DRenta210v18Servicios,
    private dutilidades: DOperacionesMatematicasServicio,
    private sessionServive: SessionStorageService,
    protected utilitariosForm: DUtilidadesFormularioServicio,
    private dReciboPagoExteriorDialogoServicio: DReciboPagoExteriorDialogoServicio,
    private denvioData: DEnvioDataServicio,) { 
    this.generalService.datosRespuesta$.subscribe((res) => {
      this.datosUsuario = res;
    });
    this.generalService.datosFirmaYTipoContribuyente$.subscribe(res => {
      this.datosFirmaContribuyente = res;
    })
    this.generalService.sugerida$.subscribe(res =>{
      this.sugerida = res;
      console.log("SUGERIDA: --------------------------------->", this.sugerida)
      this.renderViewPDF();

    });
    const usuario = this.sessionServive.retrieve('MUISCATK');
    if (usuario) {
      this.nit = usuario.NitUsuario;
    }
    this.denvioData.cambiaFlujo$.subscribe(data => {
      this.changeTab(data);
    })

    this.denvioData.reciboPago$.subscribe(res => {
      this.formulario490 = res ;
    })

    this.operacionesGenerales = new DOperacionesGeneralesIngresoServicio(
      this.dNotificacionServicio,
      this.dServicioRESTAPI,
      this.dialog
    );
    
  }


  ngOnInit() {
    
    if (!this.datosFirmaContribuyente) {
      this.datosFirmaContribuyente = this.generalService.getDatosFirmaYGranContribuyente();
    }
    if (!this.datosUsuario) {
      this.datosUsuario = this.generalService.getDatosUsuario();
    }

    if(!this.sugerida) {
      this.sugerida = this.generalService.obtenerSugerida();
    }
    
    this.route.queryParams.subscribe(params => {
      const paramValue = params['idRequest'];
      if(paramValue){
        const decodedBuffer = Buffer.from(paramValue, 'base64');
        const decodedString = decodedBuffer.toString('utf-8');
        this.anioSugerida = parseInt(decodedString.split('=')[1]);
      }
    });
  }

  obtenerExogenas() {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicioRESTAPI.obtenerInformacionExogena(this.anioSugerida, `CC-${this.datosUsuario.NitUsuario}`).subscribe(res => {
      precarga.close();
      let mediaType = 'application/pdf';
      let blob = new Blob([res], {type: mediaType});
      let filename = 'informacionExogenas';                       
      window['saveAs'](blob, filename);
    }, error => {
      precarga.close();
      const configBody = {
        title: 'Error al ejecutar el servicio',
        message: error.mensaje,
        main_button: "Cerrar"
       }
       this.modalService.show(ModalType.SUCESS, configBody);
    })
  }

  ngAfterViewInit() {
    if (this.sugerida) {
      console.log("SUGERIDA: --------------------------------->", this.sugerida)
      this.renderViewPDF();
    }
  }

  goHome(){
    this.router.navigate(['ingreso']);
  }

  mostrarMensajeAceptarSugerida() {
    let message = `<p class="text-center">Personas naturales año gravable ${this.anioSugerida}</p>`;
    message += '<p class="text-left">Estimado contribuyente, la DIAN pone a tu disposición la Declaración Sugerida, una herramienta para facilitar';
    message += `la presentación de la declaración de renta del año gravable ${this.anioSugerida}.`;
    message += 'Ten en cuenta que los datos incorporados en ella corresponden a la información exógena tributaria';
    message += `reportada por terceros a la DIAN, con fecha de corte al <b>14 de julio de ${this.anioSugerida + 1}.</b></p>`;

    message += '<p class="text-underline text-left">En caso de que no estés de acuerdo con los datos consignados en la declaración sugerida, podrás editarla e incluir los que ';
    message += 'correspondan a tu realidad jurídica, económica y financiera, sin requerirse el envío de justificaciones a la DIAN.</p>';
    
    message += '<p class="text-left">Si una vez verificados los requisitos legales, encuentras que efectivamente estás obligado a presentar la declaración y ';
    message += 'aceptas utilizar la información incorporada en la declaración sugerida, asegúrate de que los datos y cálculos de limites consignados son correctos y ';
    message += 'corresponden a tu realidad tributaria, ya que una vez elaborada de manera definitiva la declaración de renta, los valores alli consignados ';
    message += 'serán avalados con tu firma y gozarán de presunción de veracidad según lo dispuesto en el articulo 746 del Estatuto Tributario.</p>';

    message += '<p class="text-left">Lo anterior sin perjuicio de las facultades de fiscalización con que cuenta la administración tributaria, ';
    message += 'para asegurar el cumplimiento de las normas sustanciales que rigen el impuesto sobre la renta. Apuéstale a la Cultura de la Contribución!</p>';

    message += '<p class="text-left">Finalmente, si no estás de acuerdo con la información exógena reportada te sugerimos dirigirte a quien realizo el reporte para';
    message += 'que proceda a efectuar los ajustes a que haya lugar.</p>';

    const configBody = {
      title: 'Declaración sugerida de renta',
      message: message,
      main_button: "Aceptar",
      secondary_button: "Rechazar",
      main_action: "accept",
      text_align: "text-center",
      button_align: 'text-center',
      width: '450px',
      onMainAction: ()=>{this.mostrarMensajeModoDiligenciamiento();}
     }
     this.modalService.show(ModalType.SUCESS, configBody)
  }

  mostrarMensajeModoDiligenciamiento() {

    
    let config = {
      disableClose: true,
      maxWidth: '400px',
      data: {}
    };
  /*  let dialogRef = this.dialog.open(ModoDiligenciemientoComponent, config);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let objFormulario = new DInfoResumenFormulario();
        objFormulario.anio = this.anioSugerida;
        objFormulario.periodicidad = 'anual';
        objFormulario.modo = 'inicial';
        objFormulario.infoCorreccion = {esCorreccion: false, ideDocumentoCorrige: null};
        objFormulario.identificador.id = this.sugerida.ideDocumento;
        objFormulario['modoNoExperto'] = result === 'noExperto' ? true : false;
        console.log('obj: ', objFormulario);
        this.generalService.enviarEditarFormulario(objFormulario);
        }
    });*/
    ///////////////Habilitar no experto
    let objFormulario = new DInfoResumenFormulario();
        objFormulario.anio = this.anioSugerida;
        objFormulario.periodicidad = 'anual';
        objFormulario.modo = 'inicial';
        objFormulario.infoCorreccion = {esCorreccion: false, ideDocumentoCorrige: null};
        objFormulario.identificador.id = this.sugerida.ideDocumento;
        objFormulario['modoNoExperto'] = false;   //result === 'noExperto' ? true : false;
        console.log('obj: ', objFormulario);
        this.generalService.enviarEditarFormulario(objFormulario);
 }

  public renderViewPDF() {
    this.blob = new Blob([this.sugerida.pdfDocumento], {type: 'application/pdf'});
    const url = URL.createObjectURL(this.blob);
    //const el = document.getElementById("renderPDFDocument");
    const el = document.querySelector("#step-1 > div > div > div#renderPDFDocument");
    const ifrm = document.createElement("embed");
    ifrm.setAttribute("src", url + '#toolbar=0&navpanes=0&view=FitH');
    ifrm.setAttribute("type", "application/pdf");
    ifrm.style.width = "100%";
    ifrm.style.height = "100%";
    el.appendChild(ifrm);
    this.setButtonTitle();
  }


  setButtonTitle(){
    if (parseInt(this.sugerida.saldoaPagar) > 0 && this.datosFirmaContribuyente.esFirmaElectronica) {
      this.botonFirmarYPagar = 'Firmar y pagar';
    } else if (parseInt(this.sugerida.saldoaFavor) > 0 && this.datosFirmaContribuyente.esFirmaElectronica) {
      this.botonFirmarYPagar = 'Firmar';
    } else if (parseInt(this.sugerida.saldoaPagar) > 0 && !this.datosFirmaContribuyente.esFirmaElectronica) {
      this.botonFirmarYPagar = 'Firmar, formalizar y pagar';
    } else if (parseInt(this.sugerida.saldoaFavor) > 0 && !this.datosFirmaContribuyente.esFirmaElectronica) {
      this.botonFirmarYPagar = 'Firmar y formalizar';
    } else if (parseInt(this.sugerida.saldoaPagar) === 0 && this.datosFirmaContribuyente.esFirmaElectronica) {
      this.botonFirmarYPagar = 'Firmar y presentar';
    }
  }

  descargarSugerida() {
    if(this.sugerida.pdfDocumento){
      let mediaType = 'application/pdf';
      let blob = new Blob([this.sugerida.pdfDocumento], {type: mediaType});
      let filename = this.sugerida.ideDocumento;                       
      window['saveAs'](blob, filename);       
    }
  }

  descargarFormulario() {

  }

  firmarYPagar() {
    if (this.sugerida) {
      this.dSerivicoFormulario210.setDeclaracionSugerida(this.sugerida.declaracionSugerida);
      this.dSerivicoFormulario210.setModelo(this.sugerida.modelo);
      this.dSerivicoFormulario210.asignarValoresRealesDeclaracionSugerida();
      this.sugerida.declaracionSugerida = this.dSerivicoFormulario210.getDeclaracionSugerida();
      let precarga = this.dNotificacionServicio.mostrarDialogoCarga();

        this.sugerida.declaracionSugerida.valSugeridoCasilla32= this.sugerida.declaracionSugerida.valSugeridoCasilla355 != null? 
                                                                this.sugerida.declaracionSugerida.valSugeridoCasilla355:'0';
        delete this.sugerida.declaracionSugerida['status'];
        delete this.sugerida.declaracionSugerida['statusText'];
        delete this.sugerida.declaracionSugerida['valSugeridoCasilla355'];
        delete this.sugerida.declaracionSugerida['valSugeridoCasilla297'];
        delete this.sugerida.declaracionSugerida['valSugeridoCasilla302'];
        delete this.sugerida.declaracionSugerida['valSugeridoCasilla122'];
        delete this.sugerida.declaracionSugerida['valSugeridoCasilla130'];

      this.dServicio210_v18RESTAPI.actualizarDeclaracionSugerida(parseInt(this.datosUsuario.NitUsuario), this.sugerida.declaracionSugerida).subscribe(res =>{
        precarga.close();
        this.redireccionarPagoFirma();
      },error =>{
        precarga.close();
        console.log("error")
      })
    }

    // let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    // this.dServicio210_v17RESTAPI.esExtemporaneo(this.sugerida.ideDocumento).subscribe(res =>{
    //   this.extemporaneidad = <DExtemporaneo>res;
    //   if (this.extemporaneidad.esExtemporaneo) {
    //     this.mostrarDialogoExtemporaneidad();
    //   } else {
    //     if (this.sugerida) {
    //       this.dSerivicoFormulario210.setDeclaracionSugerida(this.sugerida.declaracionSugerida);
    //       this.dSerivicoFormulario210.setModelo(this.sugerida.modelo);
    //       this.dSerivicoFormulario210.asignarValoresRealesDeclaracionSugerida();
    //       this.sugerida.declaracionSugerida = this.dSerivicoFormulario210.getDeclaracionSugerida();
    //       let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    //       this.dServicio210_v17RESTAPI.actualizarDeclaracionSugerida(parseInt(this.datosUsuario.NitUsuario), this.sugerida.declaracionSugerida).subscribe(res =>{
    //         precarga.close();
    //         this.redireccionarPagoFirma();
    //       },error =>{
    //         precarga.close();
    //         console.log("error")
    //       })
    //     }
    //   }
    //   precarga.close();
    // }, error =>{
    //   precarga.close();
    //   console.log("error", error);
    // })
  }


  mostrarDialogoExtemporaneidad() {
     const configBody = {
      title: 'Mensaje de extemporaneidad',
      message: 'La declaración es extemporánea, debe ingresar a la opción Editar para liquidar la sanción correspondiente.',
      main_button: "Editar",
      main_action: "accept",
      text_align: "text-center",
      button_align: 'text-center',
      width: '450px',
      onMainAction: ()=>{this.enviarEditarFormulario();}
     }
     this.modalService.show(ModalType.SUCESS, configBody)
  }

  enviarEditarFormulario() {
   let objFormulario = new DInfoResumenFormulario();
    objFormulario.anio = this.anioSugerida;
    objFormulario.periodicidad = 'anual';
    objFormulario.modo = 'inicial';
    objFormulario.infoCorreccion = {esCorreccion: false, ideDocumentoCorrige: null};
    objFormulario.identificador.id = this.sugerida.ideDocumento;
    this.generalService.enviarEditarFormulario(objFormulario);
  }

  redireccionarPagoFirma() {
    if (parseInt(this.sugerida.saldoaPagar) > 0 && !this.datosFirmaContribuyente.esFirmaElectronica) {
      this.obtenerExtemporaneidad();
    }else if (parseInt(this.sugerida.saldoaPagar) > 0 && this.datosFirmaContribuyente.esFirmaElectronica) {
      this.mostrarDialogoFirma();
    } else if (parseInt(this.sugerida.saldoaPagar) === 0 && this.datosFirmaContribuyente.esFirmaElectronica) {
      this.mostrarDialogoFirma();
    }
  }

  mostrarDialogoFirma() {
    let dialog = this.dialog.open(DFirmaComponente, {
      // height: '600px',
      // width: '80%',
      disableClose: true
    });
    dialog.componentInstance.initComponenteFirma(this.sugerida.modelo.doc.cab.cs_id_4, this.datosUsuario.NitUsuario, this.dSerivicoFormulario210);
    dialog.afterClosed().subscribe(
        result => {
            if(result){
                if(result.firmado){
                    //this.dNotificacionServicio.mostrarDialogoInformacion(DMensajes.DOCUMENTO_FIRMADO);
                    this.step = 2;
                }
            }         
        }
    );
  }

  obtenerExtemporaneidad() {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicio210_v18RESTAPI.esExtemporaneo(this.sugerida.ideDocumento).subscribe(res =>{
      this.extemporaneidad = <DExtemporaneo>res;
      precarga.close();
      this.guardarFormularioDefinitivo();
    }, error =>{
      precarga.close();
      console.log("error", error);
    })
    
  }


  protected guardarFormularioDefinitivo() {
    let modeloBorrador: DDocumento = this.sugerida.modelo;
    modeloBorrador.doc.cuerpo = this.utilitariosForm.transformarDatosModeloParaEnviar(modeloBorrador.doc.cuerpo, DTipoTransformacionModelo.NUMERO_CADENA, this.configuracionFormulario); 
    if (this.configuracionFormulario.CASILLA_SANCION != '') {
      let validacionExtemporaneidad = this.verificarExtemporaneidad(modeloBorrador.doc.cuerpo[this.configuracionFormulario.CASILLA_SANCION]);
      // si contiene mensaje se muestra
      if (validacionExtemporaneidad.mensaje) {
          let extemporaneidadModal = this.dNotificacionServicio.mostrarDialogoConfirmacion(DMensajes.EXTEMPORANEO_TITULO, validacionExtemporaneidad.mensaje);        
          // si se requiere confirmacion se muestra dialogo con botones de confirmacion
          if (validacionExtemporaneidad.requiereConfirmacion) {
              extemporaneidadModal.afterClosed().subscribe(
                  result => {
                      if (result) {
                          this.cambiarEstadoFormulariosDefinitivo(modeloBorrador);
                      }
                  }
              );
          }
          // si no se requiere confirmacion se ejecuta la operacion 
          else {
              this.cambiarEstadoFormulariosDefinitivo(modeloBorrador);
          }
      }
      // si no contiene mensaje se ejecuta la operacion
      else {
          this.cambiarEstadoFormulariosDefinitivo(modeloBorrador);
      }
    } else {
      this.cambiarEstadoFormulariosDefinitivo(modeloBorrador);
    }
  }

  private verificarExtemporaneidad(valorModelo: string): DItemExtemporaneidad {
    let extemporaneidad = new DItemExtemporaneidad();
    // Es extemporaneo
    if (this.extemporaneidad.esExtemporaneo) {
        let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorModelo, '0');
        extemporaneidad.mensaje = resultadoOperacion ? DMensajes.EXTEMPORANEO_SIN_VALOR : DMensajes.EXTEMPORANEO_CON_VALOR;
        extemporaneidad.requiereConfirmacion = resultadoOperacion ? true : true;
    }
    // No es extemporaneo
    if (!this.extemporaneidad.esExtemporaneo) {
        let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valorModelo, '0');
        extemporaneidad.mensaje = resultadoOperacion ? DMensajes.NO_EXTEMPORANEO_CON_VALOR_MSG : null;
        extemporaneidad.requiereConfirmacion = resultadoOperacion ? true : false;
    }
    return extemporaneidad;
  }

  /**
    * @desc Funcion que actualiza el estado del formulario definitivo
    * @param {DDocumento} modeloBorrador 
    */
  private cambiarEstadoFormulariosDefinitivo(modeloBorrador: DDocumento) {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicio210_v18RESTAPI.formularioDefinitivo(this.sugerida.ideDocumento, modeloBorrador).subscribe(res =>{
      precarga.close();
      this.step = 2;
    }, error =>{
      console.log("error", error)
      precarga.close();
    })
  }

  /**
    * @desc Funcion para presentar forrmulario
    * @param {string} ideDocumento 
    */

  private presentarFormulario() {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicio210_v18RESTAPI.presentarFormulario(this.sugerida.ideDocumento).subscribe(res =>{
      precarga.close();
      this.step = 3;
      this.sugerida.declaracionSugerida.ideDocumento = `${this.sugerida.ideDocumento}`;
      this.sugerida.declaracionSugerida.numRepeticion = '1';
      this.actualizarSugerida(this.sugerida.declaracionSugerida);
      this.generarLiquidacion();
    }, error =>{
      console.log("error", error)
      precarga.close();
    })
  }


  actualizarSugerida(declaracionSugerida: any) {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicio210_v18RESTAPI.actualizarDeclaracionSugerida(parseInt(this.datosUsuario.NitUsuario), declaracionSugerida).subscribe(res =>{
      precarga.close();
    },error =>{
      precarga.close();
    })
  }

  generarLiquidacion() {
    if (parseInt(this.sugerida.saldoaPagar) > 0) {
      let objFormulario = new DInfoResumenFormulario();
      objFormulario.anio = this.anioSugerida;
      objFormulario.periodicidad = 'anual';
      objFormulario.modo = 'inicial';
      objFormulario.infoCorreccion = {esCorreccion: false, ideDocumentoCorrige: null};
      objFormulario.identificador.id = this.sugerida.ideDocumento;
      this.pagarFormularioINIT(this.sugerida.ideDocumento, this.anioSugerida, 'anual', 'inicial', objFormulario);
      this.tienePago = true;
    } else {
      this.tienePago = false;
    }
    
  }

  changeTab(tab: string) {
    const keys = Object.keys(this.tabs);
    keys.forEach(key => {
       this.tabs[key].value = false;
    })
    keys.forEach(key => {
      if (key === tab) {
        this.tabs[key].value = true;
        this.currentTab = this.tabs[key];
      }
    })
  }

  private pagarFormularioINIT(id, anio, periodo, modo, item){
    let arrayButtons = [
        {text: 'SI/YES', value: "COP", mdClass: 'warn', disabled: false} ,
        {text: 'NO', value: "USD", mdClass: 'warn', disabled: false}  
    ];
    let dialog_carga = this.dNotificacionServicio.mostrarDialogoPersonalizado('<b>ES:</b> ¿Realizará el pago en pesos colombianos? </br> <b>EN:</b> Will you make the payment in Colombian pesos?', "", "",arrayButtons,null,null,null);
        dialog_carga.afterClosed().subscribe(
            result => {
                let lannioGravable=anio;
                if(result==="USD"){
                    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                    let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPagoExterior(id);
                    observableServicio.subscribe(
                        res => {
                            precarga.close();
                            let liquidacion = <DLiquidacionReciboExterior>res;                                
                            if (liquidacion) this.dReciboPagoExteriorDialogoServicio.mostrarDialogoReciboPago(this.datosUsuario, this.datosFirmaContribuyente.esFirmaElectronica, liquidacion, null, null, true);
                        },
                        error => {
                            precarga.close();
                            this.dNotificacionServicio.mostrarDialogoError('No es posible generar el recibo de pago');                     
                        }
                    );  
                }
                if(result==="COP"){                     
                    this.pagarFormulario(id, lannioGravable, periodo,item);
                }
            }
        ); 
  }

  public pagarFormulario(idFormulario:string, anioGravable:string, periodo:string, objetoFormulario: DInfoResumenFormulario) {
    /*let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPago(idFormulario);
    observableServicio.subscribe(
        res => {
            precarga.close();
            let liquidacion = <DLiquidacionRecibo>res;
            let concepto:DConceptoLiquidacionRecibo = new DConceptoLiquidacionRecibo();
            concepto.id = '4';
            concepto.nombre = "RENTA";
            let conceptos:Array<DConceptoLiquidacionRecibo> = new Array<DConceptoLiquidacionRecibo>();
            conceptos.push(concepto);
            liquidacion.conceptos = conceptos;
            this.liquidacionSugerida = liquidacion;
        },
        error => {
            precarga.close();
              this.dNotificacionServicio.mostrarDialogoError('No es posible generar el recibo de pago');
        }
    );*/
    
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPago(idFormulario);
    observableServicio.subscribe(
        res => {
            precarga.close();
            let liquidacion:DLiquidacionRecibo;
            if(Number(anioGravable)>=2023)
            {
                liquidacion = <DLiquidacionRecibo>res.dliquidacionReciboTO;
                if(res.aporteVoluntario && res.aporteVoluntario!=null && res.aporteVoluntario !='')
                {
                this.aporteVoluntario = Number(res.aporteVoluntario);
                if( this.aporteVoluntario<=0)
                    liquidacion.conceptos.splice(1);
                else
                {
                    this.dNotificacionServicio.mostrarDialogoInformacion("Señor(a) usuario(a) <br>Usted digito la casilla 141 de aporte Voluntario, por favor genere recibo de pago 490, concepto 45");
                    liquidacion.aporteVoluntario=""+this.aporteVoluntario;
                    liquidacion.impuestoconVoluntario=JSON.parse(JSON.stringify(liquidacion.totalValorMonetario.impuesto));
                    liquidacion.totalConVoluntario=JSON.parse(JSON.stringify(liquidacion.totalValorMonetario.totalPagar));
                }
                }
                else
                 liquidacion.conceptos.splice(1);
                
            }
            else{
                liquidacion = <DLiquidacionRecibo>res;
            }
          if (liquidacion)  this.liquidacionSugerida = liquidacion;
          //this.generalServcice.enviarDatosReciboPago({contexto: this.datosContexto, tieneFirmaElectronica: this.firmaRequerida, liquidacion: liquidacion, fecha: null, mensajeAntesGuardar: null, pagoPSE: true})

        },
        error => {
            precarga.close();
             this.dNotificacionServicio.mostrarDialogoError('No es posible generar el recibo de pago');
        }
    );    

          
  }

  imprimirFormulario() {
    this.operacionesGenerales.imprimirFormulario(this.sugerida.ideDocumento);
  }




}


// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/sugerida/sugerida.component.ts